import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";




export function* loadDropngoCategory() {

  yield takeEvery(actionTypes.LOAD_DROPNGO_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let search = (action.data.search) ? action.data.search : ""

    let track_no = Helper.generateTrackNo(`DROPNGOCATEGORYLIST${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDropngoCategory(action.data);
      if (response.data.success && response.data.data) {

        yield put(actions.loadDropngoCategorySuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDropngoCategoryFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDropngoCategoryFail());
    }
  });
}

export function* loadDropngoCategoryAll() {

  yield takeEvery(actionTypes.LOAD_DROPNGO_CATEGORY_ALL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DROPNGOCATEGORYALL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDropngoCategory(action.data);
      if (response.data.success && response.data.data) {

        yield put(actions.loadDropngoCategoryAllSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDropngoCategoryAllFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDropngoCategoryAllFail());
    }
  });
}


export function* addDropngoCategory() {
  yield takeEvery(actionTypes.ADD_DROPNGO_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ADDDROPNGOCATEGORY");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);

    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.addDropngoCategory(action.data);
      if (response.data.success) {
        yield put(actions.addDropngoCategorySuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.addDropngoCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addDropngoCategoryFail());
    }
  });
}

export function* editDropngoCategory() {
  yield takeEvery(actionTypes.EDIT_DROPNGO_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITDROPNGOCATEGORY");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);

    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editDropngoCategory(action.id,action.data);
      if (response.data.success) {
        yield put(actions.editDropngoCategorySuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editDropngoCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editDropngoCategoryFail());
    }
  });
}

export function* deleteDropngoCategory() {
  yield takeEvery(actionTypes.DELETE_DROPNGO_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELETEDROPNGOCATEGORY");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.deleteDropngoCategory(action.id, action.data);
      if (response.data.success) {
        yield put(actions.deleteDropngoCategorySuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.deleteDropngoCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.deleteDropngoCategoryFail());
    }
  });
}



export function* loadDropngoCategoryEffectiveDateList() {

  yield takeEvery(actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DROPNGOEFFECTIVEDATELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDropngoCategoryEffectiveDateList(action.data);
      if (response.data.success && response.data.data) {

        yield put(actions.loadDropngoCategoryEffectiveDateListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDropngoCategoryEffectiveDateListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDropngoCategoryEffectiveDateListFail());
    }
  });
}


export function* dropngoCategoryPriceControlLoad() {
  yield takeEvery(actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DROPNGOPRICECONTROLLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.dropngoCategoryPriceControlLoad(action.data);
      if (response.data.success) {

        yield put(actions.dropngoCategoryPriceControlLoadSuccess(response.data.data));

      } else {
        alert(response.data.message);
        yield put(actions.dropngoCategoryPriceControlLoadFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.dropngoCategoryPriceControlLoadFail());
    }
  });
}



export function* dropngoCategoryPriceControlSet() {
  yield takeEvery(actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETDROPNGOPRICE");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);

    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.dropngoCategoryPriceControlSet(action.id, action.data);
      if (response.data.success) {
        yield put(actions.dropngoCategoryPriceControlSetSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.dropngoCategoryPriceControlSetFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.dropngoCategoryPriceControlSetFail());
    }
  });
}


export function* dropngoCategoryPriceRemove() {
  yield takeEvery(actionTypes.DELETE_DROPNGO_CATEGORY_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELDROPNGOPRICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.dropngoCategoryPriceRemove(action.id, action.data);

      if (response.data.success) {
        yield put(actions.dropngoCategoryPriceRemoveSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.dropngoCategoryPriceRemoveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.dropngoCategoryPriceRemoveFail());
    }
  });
}

export function* getDropngoCategoryPricePDF() {

  yield takeEvery(actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETDROPNGOPRICEPDF");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.getDropngoCategoryPricePDF(action.data);

      if (response.data.success && response.data.data) {

        yield put(actions.getDropngoCategoryPricePDFSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getDropngoCategoryPricePDFFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getDropngoCategoryPricePDFFail());
    }
  });
}


export default function* dropngoSaga() {

  yield all([fork(loadDropngoCategory)]);
  yield all([fork(loadDropngoCategoryAll)]);
  yield all([fork(addDropngoCategory)]);
  yield all([fork(editDropngoCategory)]);
  yield all([fork(deleteDropngoCategory)]);

  yield all([fork(loadDropngoCategoryEffectiveDateList)]);
  yield all([fork(dropngoCategoryPriceControlLoad)]);
  yield all([fork(dropngoCategoryPriceControlSet)]);
  yield all([fork(dropngoCategoryPriceRemove)]);
  yield all([fork(getDropngoCategoryPricePDF)]);
}
